import type { IconProps } from './../../models/icon';

export function EarthIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M18.857 20.7837C16.9662 22.2619 14.5859 23.1429 11.9998 23.1429C7.36447 23.1429 3.39017 20.3124 1.71094 16.2856H4.71413C5.50978 16.2856 6.27284 15.9695 6.83544 15.4069C7.39805 14.8443 7.71413 14.0813 7.71413 13.2856V10.7142C7.71413 9.91854 8.03019 9.15548 8.5928 8.59287C9.15542 8.03026 9.91848 7.71418 10.7141 7.71418C11.5098 7.71418 12.2728 7.39812 12.8354 6.8355C13.3981 6.27289 13.7141 5.50983 13.7141 4.71418V0.98819C18.9993 1.80426 23.0582 6.33409 23.1413 11.8279C22.2835 11.383 21.3321 11.1482 20.3656 11.1429H16.7141C15.9185 11.1429 15.1554 11.4589 14.5928 12.0215C14.0302 12.5841 13.7141 13.3472 13.7141 14.1429C13.7141 14.9385 14.0302 15.7016 14.5928 16.2642C15.1554 16.8268 15.9185 17.1429 16.7141 17.1429C17.2824 17.1429 17.8276 17.3686 18.2294 17.7705C18.6312 18.1723 18.857 18.7174 18.857 19.2857V20.7837Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M0.856934 12C0.856934 5.84598 5.84576 0.857147 11.9998 0.857147C12.5828 0.857147 13.1553 0.901916 13.7141 0.988201V4.7142C13.7141 5.50986 13.398 6.2729 12.8354 6.83551C12.2728 7.39812 11.5097 7.7142 10.7141 7.7142C9.91843 7.7142 9.15536 8.03027 8.59275 8.59288C8.03014 9.15549 7.71408 9.91855 7.71408 10.7142V13.2856C7.71408 14.0813 7.39801 14.8443 6.8354 15.4069C6.27279 15.9696 5.50973 16.2856 4.71408 16.2856H1.71089C1.16074 14.9664 0.856934 13.5187 0.856934 12ZM23.1426 11.8286C22.2843 11.3832 21.3325 11.1482 20.3655 11.1429H16.7141C15.9184 11.1429 15.1554 11.4589 14.5928 12.0215C14.0301 12.5841 13.7141 13.3472 13.7141 14.1429C13.7141 14.9385 14.0301 15.7016 14.5928 16.2642C15.1554 16.8268 15.9184 17.1429 16.7141 17.1429C17.2824 17.1429 17.8275 17.3686 18.2293 17.7705C18.6312 18.1723 18.8569 18.7174 18.8569 19.2857V20.7837C21.4657 18.7443 23.1426 15.568 23.1426 12V11.8286Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M11.9998 23.1429C18.1539 23.1429 23.1426 18.1541 23.1426 12C23.1426 5.84598 18.1539 0.857147 11.9998 0.857147C5.84576 0.857147 0.856934 5.84598 0.856934 12C0.856934 18.1541 5.84576 23.1429 11.9998 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M1.71436 16.2857H4.71436C5.51001 16.2857 6.27307 15.9697 6.83568 15.4071C7.39829 14.8445 7.71436 14.0814 7.71436 13.2857V10.7143C7.71436 9.91867 8.03042 9.15561 8.59303 8.59299C9.15564 8.03038 9.9187 7.71432 10.7144 7.71432C11.51 7.71432 12.2731 7.39824 12.8357 6.83563C13.3983 6.27303 13.7144 5.50997 13.7144 4.71432V0.977173"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1429 11.8286C22.2846 11.3832 21.3328 11.1482 20.3658 11.1429H16.7144C15.9187 11.1429 15.1556 11.4589 14.593 12.0215C14.0304 12.5841 13.7144 13.3472 13.7144 14.1429C13.7144 14.9385 14.0304 15.7016 14.593 16.2642C15.1556 16.8268 15.9187 17.1429 16.7144 17.1429C17.2826 17.1429 17.8278 17.3686 18.2296 17.7705C18.6314 18.1723 18.8572 18.7174 18.8572 19.2857V20.7771"
        />
      </g>
    </svg>
  );
}
